import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home';
import Kad from './pages/Kad';
import Demo from './pages/Demo';
import Live from './pages/Live';
import Success from './pages/Success';
import PaymentFallbackPage from './pages/PaymentFallback';
import Edit from './pages/Edit';
import Checkout from './pages/Checkout';
import Daftar from './pages/Daftar';
import SendEmail from './pages/SendEmail';
import Publish from './pages/Publish';
import SearchLocation from './pages/SearchLocation';
import AddContacts from './pages/AddContacts';
import UnderMaintenance from './pages/UnderMaintenance';
import Music from './pages/Music';
import VideoPlayer from './pages/VideoPlayer';
import YTAudio from './components/YTAudio';
import ActivateMusic from './pages/ActivateMusic';
import ActivateHideGift from './pages/ActivateHideGift';
import RSVPList from './components/RSVPList';
import RSVP from './pages/RSVP';
import DaftarNew from './pages/DaftarNew';
import OSMSearch from './components/OSMSearch';
import Dashboard from './pages/Dashboard';
import SalamKaut from './pages/SalamKaut';
import Feedback from './pages/Feedback';
import ActivateSalamKaut from './pages/ActivateSalamKaut';
import UpdateRsvpButton from './pages/UpdateRsvp';
import ActivateRsvp from './pages/ActivateRsvp';
import Checkout2 from './pages/Checkout2';
import Theme1 from './themes/theme1/Theme1';
import Manage from './pages/Manage';
import PlusCode from './pages/PlusCode';
import Tema from './pages/Tema';
import GAWrapper from './context/GAWrapper';
import Main from './pages/Main';
import PaymentFailed from './pages/PaymentFailed';
import AdminMain from './admin/pages/AdminMain';
import AdminLogin from './admin/pages/AdminLogin';
import AdminAuthRoute from './admin/components/AdminAuthRoute';
import ResellerAuthRoute from './reseller/components/ResellerAuthRoute';
import ResellerDashboard from './reseller/pages/ResellerDashboard';
import ResellerLogin from './reseller/pages/ResellerLogin';
import ResellerRegister from './reseller/pages/ResellerRegister';
import Hadiah from './pages/Hadiah';
import PilihPakej from './pages/PilihPakej';
import Gallery from './pages/Gallery';
import Pdf from './pages/Pdf';
import Wishlist from './plugins/wishlists/pages/Wishlist';

function App() {

  return (
    <Router>
      <GAWrapper>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Dashboard />} />
          <Route path="/pay/failed" element={<PaymentFailed />} />
          {/* <Route path="/" element={<Home />} /> */}
          {/* <Route path="/" element={<UnderMaintenance />} /> */}
          <Route path="/:view/:theme" element={<Kad />} />
          <Route path="/demo" element={<Demo />} />
          <Route path="/addcontacts" element={<AddContacts />} />
          <Route path="/daftar" element={<Daftar />} />
          <Route path="/profile" element={<Checkout2 />} />
          <Route path="/publish/:name/:email/:mobile/:total/:promo" element={<Publish />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/dashboard/:id" element={<Manage />} />
          <Route path="/pilih-pakej/:id" element={<PilihPakej />} />
          <Route path="/checkout/:id/:pakej" element={<Checkout />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/salamkaut/:id" element={<SalamKaut />} />
          <Route path="/hadiah/:id" element={<Hadiah />} />
          <Route path="/search" element={<OSMSearch />} />
          <Route path="/admin/aktifkanlagu" element={<ActivateMusic />} />
          <Route path="/admin/hidegift" element={<ActivateHideGift />} />
          <Route path="/admin/salamkaut" element={<ActivateSalamKaut />} />
          <Route path="/admin/updatersvp" element={<UpdateRsvpButton />} />
          <Route path="/admin/rsvp" element={<ActivateRsvp />} />
          <Route path="/rsvp/:id" element={<RSVP />} />
          <Route path="/gallery/:id" element={<Gallery />} />
          <Route path="/wishlist/:id" element={<Wishlist />} />
          {/* <Route path="/getaudio" element={<YTAudio />} /> */}
          {/* <Route path="/video" element={<VideoPlayer />} /> */}
          <Route path="/send" element={<SendEmail />} />
          <Route path="/kad/:id" element={<Live />} />
          <Route path="/kad/:id/:demoTheme" element={<Live />} />
          <Route path="/pdf/:id" element={<Pdf />} />
          <Route path="/pdf/:id/:demoTheme" element={<Pdf />} />
          <Route path="/edit/:id" element={<Edit />} />
          <Route path="/success/:id" element={<Success />} />
          <Route path="/music/:id" element={<Music />} />
          {/* <Route path="/dashboard/:id" element={<Dashboard />} /> */}
          <Route path="/fallback" element={<PaymentFallbackPage />} />
          <Route path="/theme1" element={<Theme1 />} />
          <Route path="/tema/:id" element={<Tema />} />
          {/* <Route path="/pluscode" element={<PlusCode />} /> */}
          {/* <Route path="/lokasi" element={<SearchLocation />} /> */}
          <Route path="/admin" element={<AdminAuthRoute component={AdminMain} />} />
          <Route path="/admin/login" element={<AdminAuthRoute component={AdminLogin} />} />
          <Route path="/reseller" element={<ResellerAuthRoute component={ResellerDashboard} />} />
          <Route path="/reseller/login" element={<ResellerAuthRoute component={ResellerLogin} />} />
          <Route path="/reseller/register" element={<ResellerAuthRoute component={ResellerRegister} />} />
        </Routes>
      </GAWrapper>
    </Router>
  );
}

export default App;
